import React, { FunctionComponent, useEffect } from 'react'
import { Panel } from '@afterpaytouch/core'
import { useAccountProgressionIsExistingUser, useGetCreditLimitQuery, useAppRouter } from '../../state'
import { PulseIntroModal, usePulseIntroModal, useShowPulseIntroModalOnMount } from '../PulseIntroModal'
import { ExistingUser } from './ExistingUser'
import { NewUser } from './NewUser'
import { WelcomeModal } from './WelcomeModal'
import { useShowWelcomeModalOnMount, useWelcomeModal } from './WelcomeModal/WelcomeModal.hooks'
import { TerminationNoticeModal, useShowTerminationNoticeModalOnMount, useTerminationNoticeModal } from '../TerminationNoticeModal'
import { getIdentityVerifyErrorCode } from '@afterpaytouch/portal-api/identity'
import { isAffordabilityRequiredError } from './NewUser/NewUser.hooks'
import { useUkRegFlags } from '../../hooks/useUkRegFlags/useUkRegFlags'
import { isTerminalErrorCode, Route } from '../../config/router'
import { WelcomeWithInitialLimitModal } from './WelcomeWithInitialLimitModal'

export const WelcomePanel: FunctionComponent = () => {
  const existingUser = useAccountProgressionIsExistingUser()
  const { isGbRegFlow } = useUkRegFlags()
  const shouldCheckAffordability = existingUser && isGbRegFlow
  const { error: creditLimitError } = useGetCreditLimitQuery(undefined, { skip: !shouldCheckAffordability })
  const creditLimitErrorCode = getIdentityVerifyErrorCode(creditLimitError)
  const hasAffordabilityError = shouldCheckAffordability && isAffordabilityRequiredError(creditLimitErrorCode)
  const isTerminalAffordabilityError = shouldCheckAffordability && creditLimitErrorCode != null && isTerminalErrorCode(creditLimitErrorCode)
  const router = useAppRouter()

  useEffect(() => {
    if (isTerminalAffordabilityError && creditLimitErrorCode) {
      router.push(`${Route.TERMINAL_ERROR}/${creditLimitErrorCode}`)
    }
  }, [isTerminalAffordabilityError, creditLimitErrorCode, router])

  const [isWelcomeModalOpen, { openModal: openWelcomeModal, closeModal: closeWelcomeModal }] = useWelcomeModal()
  useShowWelcomeModalOnMount(openWelcomeModal)

  const [isPulseIntroModalOpen, { openModal: openPulseIntroModal, closeModal: closePulseIntroModal }] = usePulseIntroModal()
  useShowPulseIntroModalOnMount(openPulseIntroModal)

  const [isTerminationNoticeModalOpen, { openModal: openTerminationNoticeModal, closeModal: closeTerminationNoticeModal }] = useTerminationNoticeModal()
  useShowTerminationNoticeModalOnMount(openTerminationNoticeModal)

  return (
    <>
      <Panel kind='Primary'>
        {existingUser && !hasAffordabilityError ? <ExistingUser /> : <NewUser hideOnboardingSteps={hasAffordabilityError && existingUser} />}
      </Panel>
      <WelcomeModal isModalOpen={isWelcomeModalOpen} onClose={closeWelcomeModal} />
      <PulseIntroModal isModalOpen={isPulseIntroModalOpen} closeModal={closePulseIntroModal} />
      <TerminationNoticeModal isModalOpen={isTerminationNoticeModalOpen} closeModal={closeTerminationNoticeModal} />
      <WelcomeWithInitialLimitModal />
    </>
  )
}
